/**
 * Tiny typed wrapper over localStorage. Centralized so we can swap to
 * sessionStorage / cookie storage later without touching call sites.
 */
const PREFIX = 'authmatech.';

export const storage = {
  get<T>(key: string): T | null {
    try {
      const raw = localStorage.getItem(PREFIX + key);
      return raw ? (JSON.parse(raw) as T) : null;
    } catch {
      return null;
    }
  },

  set<T>(key: string, value: T): void {
    try {
      localStorage.setItem(PREFIX + key, JSON.stringify(value));
    } catch {
      // quota / private mode — ignore.
    }
  },

  remove(key: string): void {
    try {
      localStorage.removeItem(PREFIX + key);
    } catch {
      // ignore
    }
  },

  /** Raw string variant for the theme bootstrap (must match the inline script in index.html). */
  getRaw(key: string): string | null {
    try {
      return localStorage.getItem(PREFIX + key);
    } catch {
      return null;
    }
  },

  setRaw(key: string, value: string): void {
    try {
      localStorage.setItem(PREFIX + key, value);
    } catch {
      // ignore
    }
  },
};

export const StorageKeys = {
  authToken: 'auth.token',
  authUser: 'auth.user',
  theme: 'theme',
} as const;
